interface String {
    toCamelCase(): String;
}

String.prototype.toCamelCase = function (): String {
    return this.charAt(0).toLowerCase() + this.substring(1);
};
